<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body" style="background-color: rgb(49 105 146);">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo/>
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid" style="max-width: 67%;"
                                                                                               :src="`${publicPath}app-assets/images/pages/pay.png`"
                                                                                               alt="Login V2"/></div>
              <div style="position: absolute;top: 79%;">
                <h3 class="text-white cursiveFont">Conquer The Market!</h3>
                <h3 class="text-white cursiveFont">Fast And Secure Payments</h3>
                <p class="text-white mb-0 ">Cheaper payments with free services</p>
                <p class="text-white mb-0 ">Industry low fees and no hidden charges.</p>
              </div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75" :src="`${publicPath}images/vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Welcome to VaultsPay! 👋</h3>
                <p class="card-text mb-2">Please sign-in to your account and start the adventure</p>
                <Form class="auth-login-form mt-2" @submit="sendCall" :validation-schema="loginValidationSchema" :initial-values="{email: email}">
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <Field name="email" class="form-control" type="email" placeholder="Email" v-model="email" disabled/>
                    <ErrorMessage name="email" class="text-danger" />
                  </div>
                  <div class="form-group">
                    <label class="form-label">Password</label>
                    <Field name="password" class="form-control" type="password" placeholder="Password" v-model="password"/>
                    <ErrorMessage name="password" class="text-danger" />
                  </div>
                  <div class="mt-2">
                    <Button class="btn btn-primary btn-block" :loading="loader">Sign in</Button>
                  </div>
                </form>
                <p class="text-center mt-2"><a @click="$router.push({name:'send-otp'})" href="javascript:void(0)"><span>Want To Change Your Email?</span></a></p>
                <p class="text-center mt-2"><span>Want to reset password?</span><a @click="goToResetPassword" href="javascript:void(0)"><span>&nbsp;Reset Password</span></a></p>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // this.requestPermission().then(response => {
    //   this.fcmToken = response
    // })
    if (typeof (this.$route.params.email) == 'undefined') {
      let email = localStorage.getItem('email');
      if (email != '' && email !== null) {
        this.email = email
      } else {
        this.$router.push({name: 'send-otp'});
      }
    } else {
      this.email = this.$route.params.email
    }
  },
  data() {
    return {
      loader: false,
      email: '',
      otp: '',
      password:'',
      fcmToken: null,
      loginValidationSchema:{
      email: 'required|email',
      otp: 'required|min:6',
      password: 'required|min:5',
      confirmPassword: 'required|confirmed:@password',
      carrierCode: 'required',
      phone: 'required',
      userType: 'required',
      firstName: 'required|alpha_spaces|min:2',
      lastName: 'required|alpha_spaces|min:2',
      passcode: 'required|max:4',
      confirmPasscode: 'required|confirmed:@passcode',
    }

    }
  },
  methods: {
    goToResetPassword() {
      this.$store.commit("setResetType", 1)
      this.$router.push({name: 'verify-email-general'});
    },
    sendCall() {

      let data = {
        "email": this.email,
        "password": this.password,
        // "fcm_device_token": this.fcmToken,
      }
      this.loader = true
      this.makeRequest('post', 'v1/login', data).then(callResponse => {

        this.loader = false

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let passcodeSet = callResponse.response.data.data.passcode_set;
            let customerId = callResponse.response.data.data.id;
            this.$store.commit('setLoggedInUser', callResponse.response.data.data);

            if (passcodeSet == 1) {
              this.$router.push({name: 'passcode-login', params: { customerId: customerId }})
            } else {
              this.$router.push({name: 'set-passcode', params: { customerId: customerId }})
            }
          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
  },
}
</script>

